<template>
  <div class="left-bar auth">
    <div>
      <a class="return_link" href="https://croinc.ru/">
        <span class="return_link__icon">
          <i class="material-icons">chevron_left</i>
        </span>
        <small class="return_link__text">Вернутся на главную</small>
      </a>
    </div>
    <div class="logo_content">
      <div class="main_logo">
        <router-link :to="{ path: '/' }">
          <img
              style="{display: inline-block}"
              src="@/../public/images/logo.svg"
              alt="company-logo"
              class="main_logo__img"
          />

        </router-link>
      </div>

      <h1 class="logo_content__heading">
        Начните работу с Croinc
      </h1>

      <p class="logo_content__text">
        Время — один из самых ценных активов в жизни современного человека. И в бизнесе. Сервис онлайн-бронирования
        позволяет это самое время экономить — и владельцам бизнеса, и клиентам.
      </p>

      <img class="logo_content__hero-img" src="@/../public/images/sign-up_hero-img.png" alt="croinc">

    </div>

  </div>
</template>

<script>


import {publicPath} from "@/../vue.config";

export default {
  name: "LeftRegisterBar",
  data() {
    return {
      base_url: publicPath
    }
  }
}
</script>

<style lang="sass" scoped>
.desktop
  .left-bar
    .main_logo
      display: block
      margin-bottom: 32px
      &__type
        font-size: 12px
        position: relative
        top: -4px
        left: 1px
        letter-spacing: 10px
        opacity: 0.4
    .worker-list
      padding: 0

.left-bar
  &.auth
    position: fixed
  position: relative
  background-image: linear-gradient(158deg, #9AE6E5 3%, #8582BD)
  width: 420px
  @media (min-width: 1189px)
    width: 30%
  height: 100vh
  overflow-y: auto
  padding: 74px
  z-index: 2
  min-height: 100vh

  .logo_content
    margin-top: 100px
    &__heading
      font-size: 36px
      font-weight: 500
      color: #394D55
    &__text
      font-size: 14px
      padding: 24px 0
      color: #394D55
    &__hero-img
      padding: 14px 0
      margin: 0 auto
      max-width: 100%
      height: auto

  .main_logo
    display: none

  .info_label
    text-align: left

  .advanced_link
    text-align: center

    .info_label
      text-align: center

</style>

